<div class="container main-font timeline col-sm-12">
  <ul
    class="nav nav-pills nav-fill col-lg-1 col-md-2 col-sm-3 mx-lg-auto mx-md-auto flex-grow-1">
    <li role="button" class="nav-item text-wrap m-1">
      <div class="dropdown">
        <button
          class="btn nav-link nav-link-active border b-top p-1 b-all"
          type="button"
          [value]="this.year"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          (click)="checkClear()">
          {{ this.selectedYear }}
        </button>
        <ul class="dropdown-menu">
          <li
            *ngFor="let year of years; index as i"
            (click)="selectYears(year)"
            onkeydown="">
            <a class="dropdown-item">{{ year }}</a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <ul class="nav nav-pills nav-fill flex-nowrap months-lg-pills">
    <li
      role="button"
      class="nav-item col-1 m-1"
      *ngFor="let tab of months"
      onkeydown="">
      <button
        class="nav-link border main-font"
        data-bs-toggle="dropdown"
        [ngClass]="{
          'b-left': tab.value == 1,
          'b-right': tab.value == 12,
          'nav-link-active': selectedMonth == tab.value
        }"
        [disabled]="
          selectedYear < userYear ||
          (selectedYear == userYear && tab.value < userMonth) ||
          (selectedYear >= currentYear && tab.value > currentMonth)
        "
        (click)="checkClear(tab)">
        {{ tab.viewValue }}
      </button>
    </li>
  </ul>

  <ul class="nav nav-pills nav-fill col-sm-3 months-sm-pills flex-grow-1">
    <li role="button" class="nav-item text-wrap m-1 w-100" onkeydown="">
      <div class="dropdown">
        <button
          class="btn nav-link nav-link-active border b-all p-1"
          type="button"
          [value]="this.month"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          (click)="checkClear()">
          {{ this.selectedMonth ? this.selectedMonthName : 'Seleziona mese' }}
        </button>
        <ul class="dropdown-menu">
          <li
            *ngFor="let month of months; index as i"
            (click)="selectMonths(month)"
            onkeydown=""
            [ngClass]="{
              'd-none':
                selectedYear < userYear ||
                (selectedYear == userYear && month.value < userMonth) ||
                (selectedYear >= currentYear && month.value > currentMonth)
            }">
            <a class="dropdown-item">{{ month.viewValue }}</a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <ng-container *ngIf="selectedMonth && enableDragDrop">
    <ul
      class="nav nav-pills nav-fill col-lg-2 col-md-4 col-sm-5 mx-lg-auto mx-md-auto flex-grow-2">
      <li role="button" class="nav-item text-wrap m-1">
        <div class="dropdown" data-bs-toggle="dropdown">
          <button
            class="btn nav-link nav-link-active border b-left-bottom b-right-bottom b-all p-1 justify-content-center"
            type="button"
            [value]="week"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            *ngIf="week?.start_date && week?.end_date">
            <div>
              {{ week?.start_date | date: 'dd/MM' }} -
              {{ week?.end_date | date: 'dd/MM' }}
            </div>
          </button>

          <button
            class="btn nav-link nav-link-active border b-left-bottom b-right-bottom b-all p-1 justify-content-center select-week"
            type="button"
            [value]="week"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            *ngIf="!week?.start_date || !week?.end_date">
            Seleziona Settimana
          </button>

          <ul class="dropdown-menu">
            <li
              *ngFor="let week of data.weeks; index as i"
              (click)="selectWeeks(week)"
              onkeydown="">
              <a class="dropdown-item"
                >{{ week.start_date | date: 'dd/MM' }} -
                {{ week.end_date | date: 'dd/MM' }}</a
              >
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </ng-container>
</div>
